import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import PropTypes from 'prop-types';
/**
 * `MenuTitle` is another valid Menu child, but this does not have any accessibility attributes associated
 * (so this should not be used in place of the `EllipsisMenu` prop `label`).
 *
 * @return { object } -
 */

var MenuTitle = function MenuTitle(_ref) {
  var children = _ref.children;
  return createElement("div", {
    className: "woocommerce-ellipsis-menu__title"
  }, children);
};

MenuTitle.propTypes = {
  /**
   * A renderable component (or string) which will be displayed as the content of this item.
   */
  children: PropTypes.node
};
export default MenuTitle;
//# sourceMappingURL=menu-title.js.map